import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import io from 'socket.io-client';
import {
    LoginContainer,
    LoginBox,
    LoginTitle,
    LoginForm,
    InputField,
    LoginButton
} from '../styles/loginStyles';

const apiUrl = process.env.REACT_APP_API_URL; 
const apiUrlSocket = process.env.REACT_APP_API_URL_SOCKET;

const socket = io(`${apiUrlSocket}`, {
  transports: ['websocket'],
});

const Login = ({ setToken }) => {
    const [username, setUsername] = useState('');
    const [password, setPassword] = useState('');
    const navigate = useNavigate(); 

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            const response = await fetch(`${apiUrl}/api/auth/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ username, password }),
            });

            if (response.ok) {
                const { accessToken, userId, userName, refreshToken } = await response.json();
                // Guarda en localStorage
                localStorage.setItem('authToken', accessToken);
                localStorage.setItem('refreshToken', refreshToken);
                localStorage.setItem('userId', userId);
                localStorage.setItem('userName', userName);

                // Emitir el evento de usuario conectado
                socket.emit('user_connected', userId);
            
                
                // Redirige a la sala de chats
                navigate('/chat'); // Redirige a la página de chat
            } else {
                alert('Invalid credentials');
            }
        } catch (error) {
            console.error('Error:', error);
            alert('An error occurred');
        }
    };

    return (
        <LoginContainer>
          <LoginBox>
            <LoginTitle>Sign In</LoginTitle>
            <LoginForm>
              <InputField type="text" value={username} onChange={(e) => setUsername(e.target.value)} placeholder="Username" />
              <InputField type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" />
              <LoginButton onClick={handleLogin}>Login</LoginButton>
            </LoginForm>
          </LoginBox>
        </LoginContainer>
      );
    };


export default Login;
